// @flow
export const LOAD_BOOKMARKS = "LOAD_BOOKMARKS";
export const EDIT_BOOKMARK = "EDIT_BOOKMARK";
export const DELETE_BOOKMARK = "DELETE_BOOKMARK";
